import { useSignalRContext } from "../Contexts/SignalRContext";
import { isReceivingLiveUpdates } from "../../utilities/helpers/connectionStatus";
import { useOnlineStatus } from "./useOnlineStatus";

export const useLiveUpdates = (): boolean => {
  const { connection, isReconnecting, connectionError } = useSignalRContext();
  const isOnline = useOnlineStatus();

  return isReceivingLiveUpdates({
    isOnline,
    hasLiveConnection: !!connection,
    isReconnecting,
    hasConnectionError: !!connectionError,
  });
};
